import { Subtitle2 } from '@backoffice-frontend/patterns'
import { ChevronRightIcon } from '@moia-dev/pace-icons'
import type { ReactNode } from 'react'

type SecondaryActionFlowButtonProps = {
  children: ReactNode
  onClick?: VoidFunction
  loading?: boolean
  color?: 'default' | 'critical'
}

export const SecondaryActionFlowButton = ({
  children,
  onClick,
  loading = false,
  color = 'default',
}: SecondaryActionFlowButtonProps) => (
  <button
    onClick={onClick}
    disabled={loading}
    css={theme => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      minWidth: 300,
      padding: theme.spacing(1, 1, 1, 2),
      border: '2px solid',
      borderRadius: 8,
      cursor: 'pointer',
      '&.default': {
        color: theme.semantic.ColorContentDefault,
        borderColor: theme.semantic.ColorContentDefault,
        backgroundColor: 'transparent',
      },
      '&.critical': {
        color: theme.semantic.ColorCriticalContrast,
        borderColor: theme.semantic.ColorCriticalContrast,
        backgroundColor: theme.semantic.ColorSurfaceCritical,
      },
    })}
    className={color}
  >
    <Subtitle2 css={{ color: 'inherit' }}>{children}</Subtitle2>
    <ChevronRightIcon />
  </button>
)
